// extracted by mini-css-extract-plugin
export default {"clock":"style_clock__SAwun"};